<template>
  <div class="div_soi">
    <SplitContainer21 style="height:100%" :layout="12">
      <template #top>
        <TableMain name="one table" ref="TestTable2" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :hb_table_class="'hb_table_sotracking_class'" :loading_width="55"
          :isBusy="isBusy" @on_query="on_query" @on_cell_button_click="on_cell_button_click"
          @current_changed="current_changed" :show_toolbar_button="[0, 0, 0, 0, 0]">
          <template #query>
            {{ $t("common.create_date") }}：
            <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
              align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
              :picker-options="pickerOptions()">
            </el-date-picker>
            {{ $t("common.plantform_order_num") }}：
            <el-input style="width: 200px" size="small" clearable placeholder="" v-model="SalesId"
              class="input-with-select ml-2">
            </el-input>
            {{ $t("common.invent") + $t("common.num") }}：<el-input clearable size="small" style="width: 120px"
              v-model="ItemId"></el-input>
          </template>
          <template #toolbar="">
            <el-checkbox class="ml-2" :label="$t('common.only_so_uncomplated')" v-model="onlyCompleted"
              @change="onlyCompleteChange($refs.TestTable2.SetData)">
            </el-checkbox>
            <el-checkbox class="ml-2" :label="$t('common.not_vend_price_confirm')" v-model="onlyHasPriceConfirm"
              @change="onlyCompleteChange($refs.TestTable2.SetData)">
            </el-checkbox>
            <el-checkbox class="ml-2" :label="$t('common.not_vend_price_init')" v-model="onlyHasPrice"
              @change="onlyCompleteChange($refs.TestTable2.SetData)">
            </el-checkbox>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain name="two table" :fields="dispatch_fields" :show_query_container="false"
          ref="saleOrderDispatchSearchTable" :title="table_title.title2" :table_height_adjust="8"
          :isBusy="isBusy_table1" :loading_width="60" :hb_table_class="'hb_table_soi_sods_class'" :show_email="false"
          :table_height_default="'calc(100vh - 170px)'" :show_toolbar="false" :show_toolbar_state="false">
        </TableMain>
      </template>
    </SplitContainer21>
    <el-drawer :title="drawer_sod_price_title" :visible.sync="drawer" :with-header="true" :size="'60%'">
      <TableMain name="two table" :fields="fields2" :show_query_container="false" ref="table_sod_price"
        :title="table_title.title3" :table_height_adjust="8" :isBusy="isBusy_table1" :loading_width="60"
        :hb_table_class="'hb_table_price_class2'" :show_email="false" :table_height_default="'calc(100vh - 170px)'"
        :show_toolbar="false" :show_toolbar_state="false">
      </TableMain>
    </el-drawer>
    <el-drawer :title="drawer_sod_price_vend_title" :visible.sync="drawer1" :with-header="true" :size="'60%'">
      <TableMain name="three table" :fields="fields3" :show_query_container="false" ref="table_sod_price_vend"
        :title="table_title.title4" :table_height_adjust="8" :isBusy="isBusy_table2" :loading_width="60"
        :hb_table_class="'hb_table_price_vend_class2'" :show_email="false" :table_height_default="'calc(100vh - 170px)'"
        :show_toolbar="false" :show_toolbar_state="false">
      </TableMain>
    </el-drawer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as PurchImplementationController from "../../controllers/mm/PurchImplementationController"
import * as commonController from "../../controllers/commonController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as VendPurchaseQuoteOutController from "../../controllers/sd/VendPurchaseQuoteOutController"
import * as VendInitialQuoteController from "../../controllers/sd/VendInitialQuoteController"
import * as SaleOrderDispatchSearchController from "../../controllers/sd/saleOrderDispatchSearchController"
import SplitContainer21 from "../components/container/SplitContainer21"

export default {
  name: "SOTracking",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer21
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_po_implementation",
        title2: "table_sales_dispatch_detail",
        title3: "table_vend_purch_price",
        title4: "table_vend_initornal_price",
      },
      isBusy_table1: false,
      isBusy_table2: false,
      fields: PurchImplementationController.fields.fields,
      dispatch_fields: PurchImplementationController.fields.dicpatch_fields,
      dataForm: _.cloneDeep(PurchImplementationController.dataForm),
      dataFormList: [],
      all_role_users: [],
      rules: PurchImplementationController.rules,
      SalesId: "", //销售订单编号
      ItemId: "", //物料编号
      isBusy: false,
      tab_index: 0,
      date_range: "",
      fields2: VendPurchaseQuoteOutController.fields.default,
      fields3: VendInitialQuoteController.fields.default,
      drawer: false,
      drawer1: false,
      drawer_sod_price_title: "", //供应商实际采购价确认
      drawer_sod_price_vend_title: "", //供应商采购报价
      onlyCompleted: true,
      onlyHasPriceConfirm: false,
      onlyHasPrice: false
    }
  },
  async created() {
    await this.getAllRoleUsers()
  },
  mounted() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.date_range = [start, end]
  },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    async on_query(set_data, date_range) {
      this.isBusy = true
      let _params = {}

      if (!_.isNull(this.date_range) && this.SalesId == "") {
        let _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params.FromDate = _fromDate
        _params.ToDate = _toDate
      }

      if (this.SalesId != "") {
        _params.SalesId = this.SalesId
      }
      if (this.ItemId != "") {
        _params.ItemId = this.ItemId
      }

      if (this.ItemId != "" || this.SalesId != "") {
        if (_params.FromDate) {
          delete _params.FromDate
        }
        if (_params.ToDate) {
          delete _params.ToDate
        }
      }
      set_data([])
      let _result = await PurchImplementationController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          this.getApprover(t)
        })
        this.soline_dt = _result[0]
        this.onlyCompleteChange(set_data)
      }
      this.isBusy = false
    },
    async current_changed(old, current) {
      this.$refs.saleOrderDispatchSearchTable.SetData([])
      if (current) {
        let _result = await SaleOrderDispatchSearchController.methods.getDispatchItemsSql({ SalesLineId: current.SalesLineId })
        if (!_.isNull(_result) && _result && _result.length > 0) {
          let rt = _.orderBy(_result[0], ["id"], ["desc"])
          _.each(rt, (t) => {
            commonController.methods.getUserNameFromRole(
              this.all_role_users,
              t,
              "fcGetDocumentApprover",
              "Approver"
            )
            commonController.methods.getUserNameFromRole(
              this.all_role_users,
              t,
              "fcGetDocumentApprover",
              "Up_Approver"
            )
            t.ApproveRemark = ""
          })
          this.$refs.saleOrderDispatchSearchTable.SetData(rt)
        }
      }
    },
    on_cell_button_click(data) {
      if (data.field.key == "hasPriceConfirmState") {
        this.drawer = true
        this.drawer_sod_price_title = this.$t("common.invent") + this.$t("common.num") + "：" + data.item.ItemId + "，" + this.$t("table.table_vend_purch_price")
        ///报价确认
        setTimeout(() => {
          this.drawerPrice(data)
        }, 100)
      }
      if (data.field.key == "hasInitPriceState") {
        this.drawer1 = true
        this.drawer_sod_price_vend_title = this.$t("common.invent") + this.$t("common.num") + "：" + data.item.ItemId + "，" + this.$t("table.table_vend_initornal_price")
        ///初始报价
        setTimeout(() => {
          this.drawerPriceVend(data)
        }, 100)

      }
    },
    //报价确认
    async drawerPrice(data) {
      this.$refs.table_sod_price.SetData([])
      let dt = []
      let _params = { is_deleted: { "=": 0 }, ItemId: { "=": data.item.ItemId } }
      let _result = await VendPurchaseQuoteOutController.methods.getData(_params, "VendQuote")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        if (_result[0].Result) {
          _.each(_result[0].Result.Data[0], (t) => {
            commonController.methods.getUserNameFromRole(
              this.all_role_users,
              t,
              "fcGetDocumentApprover",
              "VQApprover",
              t.fcCheckDocumentApproved
            )
            dt.push(t)
          })

        }
      }
      let _result1 = await VendPurchaseQuoteOutController.methods.getData(_params, "VendInternalQuote")
      if (!_.isNull(_result1) && _result1 && _result1.length > 0) {
        if (_result1[0].Result) {
          _.each(_result1[0].Result.Data[0], (t) => {
            commonController.methods.getUserNameFromRole(
              this.all_role_users,
              t,
              "fcGetDocumentApprover",
              "VQApprover",
              t.fcCheckDocumentApproved
            )
            dt.push(t)
          })

        }
      }
      dt = _.filter(dt, { fcCheckDocumentApproved: true })
      this.$refs.table_sod_price.SetData(_.orderBy(dt, ["id"], ["desc"]))
    },
    //初始报价
    async drawerPriceVend(data) {
      this.$refs.table_sod_price_vend.SetData([])
      let _params = { is_deleted: { "=": 0 }, ItemId: { "=": data.item.ItemId } }
      let _result = await VendInitialQuoteController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        if (_result[0].Result) {
          _.each(_result[0].Result.Data[0], (t) => {
            commonController.methods.getUserNameFromRole(
              this.all_role_users,
              t,
              "fcGetDocumentApprover",
              "VIQApprover",
              t.fcCheckDocumentApproved
            )
          })
          let dt = _.filter(_result[0].Result.Data[0], { fcCheckDocumentApproved: true })
          this.$refs.table_sod_price_vend.SetData(_.orderBy(dt, ["id"], ["desc"]))
        }
      }
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOApprover",
        "SOApprover",
        t.fcCheckSOApproved
      )
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOCreditControlApprover",
        "SOCreditControlApprover",
        t.fcCheckSOCreditControlApproved
      )
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOPriceDiffApprover",
        "SOPriceDiffApprover",
        t.fcCheckSOPriceDffApproved
      )
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    onlyCompleteChange(set_data) {
      let dt = this.soline_dt
      if (this.onlyCompleted) {
        dt = _.filter(dt, (t) => {
          if (t.valid_remain == 0 && t.isAllDispatched == 0) {
            return t
          }
          else if (t.valid_remain > 0) {
            return t
          }
        })
      }
      if (this.onlyHasPriceConfirm) {
        dt = _.filter(dt, { hasPriceConfirm: false })
      }
      if (this.onlyHasPrice) {
        dt = _.filter(dt, { hasInitPrice: false })
      }
      set_data(_.orderBy(dt, ["id", "SalesLineId"], ["desc", "asc"]))
    }
  },
}
</script>
<style>
.hb_table_sotracking_class {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 235rem;
}

.hb_table_price_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 220rem;
}

.hb_table_price_vend_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 180rem;
}

.hb_table_soi_sods_class {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 200rem;
}

.div_soi {
  height: 100%;
}

.div_soi .el-drawer__header {
  font-size: 1.1rem;
  color: black;
}
</style>
